import React, { useState } from "react";
import { XIcon } from "@heroicons/react/outline";

const SearchBar = ({ placeholder, callbackSearch }) => {
  const [query, setQuery] = useState("");

  const handleSearchInput = (event) => {
    const searchQuery = event.target.value;
    setQuery(searchQuery);
  };

  return (
    <div className="flex justify-center">
      <div className="mb-3 w-full">
        <div className="relative flex flex-row items-stretch w-full mb-4">
          <input
            type="text"
            onChange={handleSearchInput}
            onKeyPress={(event) => {
              if (event.key === "Enter") {
                callbackSearch(query);
              }
            }}
            value={query}
            className="h-full form-control relative flex-auto min-w-0 block w-full px-4 py-4 text-lg font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            placeholder={placeholder}
            aria-label="Search"
            aria-describedby="button-addon2"
          />
          <button
            className="btn inline-block px-6 py-2 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700  focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out items-center"
            type="button"
            onClick={() => {
              setQuery("");
              callbackSearch("");
            }}
            id="button-addon2"
          >
            <XIcon className="w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
